import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import css from './index.module.less';

export function HeroSection() {
  const { t } = useTranslation();

  return (
    <div className={clsx(css['hero-container'])}>
      <h1 className={clsx(css['hero-title'])}>
        CodeFlicker
        <span className={clsx(css['cli-highlight'])}> CLI</span>
      </h1>
      <div className={clsx(css['hero-description'])}>{t('cli.hero.description')}</div>
    </div>
  );
}
